import { Container, Row, Col } from 'react-bootstrap';

import plus from '../../../../../../../assets/images/icons/plus.svg';
import trash from '../../../../../../../assets/images/icons/trash.svg';
import Title from './components/Title';
import EmailCard from './components/EmailCard';
import { ChangeEvent, Dispatch, SetStateAction } from 'react';
import { EmailsCardContainer, Container as StyledContainer } from './styles';
import NoData from '../../../../../../../components/NoData';
import RemoveEmailModal from './components/RemoveEmailModal';
import AddEmailModal from './components/AddEmailModal';
import { EmailsObjectType } from '../../../../types';

interface EmailsCardInterface {
  setAddEmailModalShow: Dispatch<SetStateAction<boolean>>;
  hasEmailsToBeRendered: boolean;
  emails: EmailsObjectType[];
  setEmailToRemove: Dispatch<SetStateAction<string>>;
  setRemoveEmailModalShow: Dispatch<SetStateAction<boolean>>;
  emailToRemove: string;
  removeEmail: () => void;
  addEmailModalShow: boolean;
  emailToAdd: string;
  handleEmailToAddChange: (event: ChangeEvent<HTMLInputElement>) => void;
  addEmail: () => void;
  removeEmailModalShow: boolean;
  resetEmails: () => void;
  hasOriginalEmailsChanged: boolean;
  titleLabel: string;
  emailOwnerName: string;
  handleEmailOwnerNameChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export default function EmailsCard({
  setAddEmailModalShow,
  hasEmailsToBeRendered,
  emails,
  setEmailToRemove,
  setRemoveEmailModalShow,
  emailToRemove,
  removeEmail,
  addEmailModalShow,
  emailToAdd,
  handleEmailToAddChange,
  addEmail,
  removeEmailModalShow,
  resetEmails,
  hasOriginalEmailsChanged,
  titleLabel,
  emailOwnerName,
  handleEmailOwnerNameChange,
}: EmailsCardInterface) {

  return (
    <>
      <StyledContainer>
        <Title
          hasOriginalEmailsChanged={hasOriginalEmailsChanged}
          resetEmails={resetEmails}
          addImage={plus}
          setAddEmailModalShow={setAddEmailModalShow}
          titleLabel={titleLabel}
        />
        {hasEmailsToBeRendered && (
          <EmailsCardContainer>
            <Container>
              <Row xs={1} md={1} lg={3}>
                {emails?.map((email) => (
                  <Col key={email.email}>
                    <EmailCard
                      email={email.email}
                      emailOwnerName={email.emailOwnerName}
                      setEmailToRemove={setEmailToRemove}
                      setRemoveEmailModalShow={setRemoveEmailModalShow}
                      deleteImage={trash}
                    />
                  </Col>
                ))}
              </Row>
            </Container>
          </EmailsCardContainer>
        )}

        {!hasEmailsToBeRendered && (
          <NoData
            icon="emptyBox"
            label={(
              <>
              Não há nenhum e-mail adicionado. Para adicionar um e-mail, clique no ícone
                {' '}
                <img src={plus} alt="add" className="primaryColor" />
                {' '}
              acima
              </>
            )}
          />
        )}
      </StyledContainer>

      <RemoveEmailModal
        removeEmailModalShow={removeEmailModalShow}
        emailToRemove={emailToRemove}
        setRemoveEmailModalShow={setRemoveEmailModalShow}
        removeEmail={removeEmail}
      />

      <AddEmailModal
        addEmailModalShow={addEmailModalShow}
        emailToAdd={emailToAdd}
        handleEmailToAddChange={handleEmailToAddChange}
        setAddEmailModalShow={setAddEmailModalShow}
        addEmail={addEmail}
        emailOwnerName={emailOwnerName}
        handleEmailOwnerNameChange={handleEmailOwnerNameChange}
      />
    </>
  );
}
